import { z } from 'zod'

/**
 * What a vendor's price is per. `table` is for flowers only (the offering
 * schema refuses it elsewhere). Mirrors the Prisma `VendorPriceUnit` enum
 * (`check:enums`).
 */
export const VENDOR_PRICE_UNITS = ['event', 'hour', 'guest', 'item', 'table'] as const

export const vendorPriceUnitSchema = z.enum(VENDOR_PRICE_UNITS)

export type VendorPriceUnit = z.infer<typeof vendorPriceUnitSchema>

/** How a price reads after its amount: "$1,200 per event", "$40 each". */
export const VENDOR_PRICE_UNIT_LABELS: Record<VendorPriceUnit, string> = {
  event: 'per event',
  hour: 'per hour',
  guest: 'per guest',
  item: 'each',
  table: 'per table',
}
